import React from "react"
import { Switch, Route } from 'react-router';
import Home from './Wizards/PatientRegistration'
// import PharmacyRegistration from './Wizards/PharmacyRegistration'
import { Router } from 'react-router-dom';
import history from '../History/Index';
import NotFound from "./HandlePages/NotFound";
import NotHaveAccess from "./HandlePages/NotHaveAccess";

function Container() {
    
    return (
        <main>
            <Router history={history}>
                <Switch>
                <Route path="/access-denied" component={NotHaveAccess} exact />
                <Route path='/:id' component={Home} exact/>
                {/* { localStorage.getItem("isValidated") !== true?
                    <Route path='/' component={Home} exact/>
                    :
                    <Route path='*' exact={true} component={NotFound} />
                } */}
                <Route path='*' exact={true} component={NotFound} />
                

                    {/* <Route path="/PharmacyRegistration" component={PharmacyRegistration} exact /> */}
                </Switch>
            </Router>
        </main>
    )
}
export default Container;